export default __webpack_public_path__ + "static/exp4-4a61147fa7ed4ceb969da33aeb9ab7da.jpg";